export default __webpack_public_path__ + "app/resources/CNAG_LOGO.png";